






import {Component, Vue} from 'vue-property-decorator';
@Component({
  name: "NoneForm"
})
export default class NoneForm extends Vue {

}
